import React, { useState, useEffect } from "react";
import Header from "components/Headers/Header";
import { Button, Card, CardBody, Col, Container, Modal, ModalBody, Row, Alert } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import previewBadge from "../../assets/img/custom/endorsment_welcome_image.png";
import endorseImage from "../../assets/img/custom/endorse.png";
import oldEndorseImage from "../../assets/img/custom/ENDORSE-AD_FHP_BAND_COLOR_.png";

const Endorsement = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          <div className="bg-gradient-primary p-4 text-white">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
                  VIDEO GUIDE
                </span>
                <h2 className="text-white mb-0 mt-1 font-weight-700">
                  Endorsements
                </h2>
                <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "0.95rem" }}>
                  Learn how to navigate and manage your endorsements.
                </p>
              </div>
              <Button color="secondary" className="font-weight-bold shadow-sm mt-3 mt-md-0" onClick={toggle}>
                Go to Site
              </Button>
            </div>
          </div>

          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <div 
              className="embed-responsive embed-responsive-16by9 rounded-4 overflow-hidden shadow-sm bg-black mb-4"
              style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}
            >
              <iframe
                className="embed-responsive-item w-100"
                style={{ minHeight: isSmallScreen ? "250px" : "480px", border: "none" }}
                src="https://www.youtube.com/embed/C9MygYzfkkY"
                title="Endorsements Guide"
                allowFullScreen
              ></iframe>
            </div>

            <Row className="mt-5 align-items-stretch">
              <Col md="6" className="mb-4">
                <img src={endorseImage} alt="Endorsements New" className="w-100 rounded shadow-sm" style={{ height: "100%" }} />
              </Col>
              <Col md="6" className="mb-4">
                <img src={oldEndorseImage} alt="Endorsements Original" className="w-100 rounded shadow-sm" style={{ height: "100%" }} />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
      
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="lg"
        className="modal-dialog modal-dialog-centered"
      >
        <div className="modal-content border-0 rounded-4 overflow-hidden shadow-lg">
          <div className="bg-gradient-primary p-4 text-white text-center">
            <h2 className="text-white mb-0 font-weight-700">Athlete Endorsements</h2>
            <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "0.95rem" }}>
              Configure your endorsement plans and settings
            </p>
          </div>
          <ModalBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <Row className="align-items-center">
              <Col md="7">
                <div className="bg-white p-4 rounded-4 shadow-sm mb-3">
                  <p className="font-weight-600 text-dark mb-3" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>
                    Build your supporter base and receive long-term backing from your fans.
                  </p>
                  <p className="text-muted" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                    Plus, years later supporters can verify to their friends that they saw potential in your talent and backed you early.
                  </p>
                </div>
                
                <div className="bg-gradient-warning text-white p-3 rounded-4 shadow-sm mb-3 d-flex align-items-start" style={{ borderLeft: "4px solid #fb6340" }}>
                  <i className="fas fa-exclamation-triangle mt-1 mr-3 text-white" style={{ fontSize: "20px" }}></i>
                  <div>
                    <strong className="text-white" style={{ fontSize: "0.95rem" }}>Important Note:</strong>
                    <p className="mb-0 text-white mt-1" style={{ fontSize: "0.85rem", lineHeight: "1.4", opacity: 0.9 }}>
                      Endorsements are purchased by fans to support you. You can set your price details in your Profile. You do not need to buy them yourself.
                    </p>
                  </div>
                </div>
              </Col>
              
              <Col md="5" className="text-center">
                <div className="p-3 bg-white rounded-4 shadow-sm mb-4">
                  <img src={previewBadge} className="img-fluid rounded-3" style={{ maxHeight: "180px", objectFit: "contain" }} alt="endorsement preview" />
                </div>
                
                <div className="d-flex flex-column gap-3 justify-content-center">
                  <a
                    href="https://youtu.be/VPOnEKsHG0Q"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-100 mb-2 d-block"
                  >
                    <Button color="outline-danger" className="w-100 rounded-pill font-weight-bold">
                      <i className="fas fa-play mr-2"></i> Play Intro Video
                    </Button>
                  </a>
                  <Link
                    to="/admin/profile"
                    className="w-100 d-block"
                    onClick={toggle}
                  >
                    <Button color="primary" className="w-100 rounded-pill font-weight-bold shadow">
                      Continue to My Profile
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Endorsement;
